import { createApp } from "vue";
import Vuex from 'vuex'

import App from "../App.vue";
import tab from './tab'
import user from './user'
const app = createApp(App);
app.use(Vuex)
export default new Vuex.Store({
  mutations: {
    setParameter(state, payload) {
      state.parameter = payload;
    }
  },
  modules: {
    tab,
    user
  }
})
